/// \file passwordUseStates.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import React, {useState} from 'react';
import { SetFilter } from '../../../components/filter/setFilter';
import { passwordUseStateInterface } from './passwordUseStateInterface';
import CheckingPasswords from '../../../services/checkingPassword';
const PasswordUseStates = ():passwordUseStateInterface => {

//question type
const questionTypeDropdown = [
  "In what city did you meet your significant other?",
  "What was your childhood nickname",
  "What is the last name of your favorite childhood friend?",
  "What street did you live on in third grade?",
  "What is the middle name of your oldest child?",
  "What was the last name of your third grade teacher?",
  "In what town was your first job",
  "What is the name of the street on which you grew up?",
  "What is the last name of the bast man at your wedding?",
  "What is the last name of the maid of honor at your wedding?",
  "What was the make of your first car?",
  "What is the name of your favorite book?",
  "Who is your favorite author?",
  "Who is your favorite all-time movie character?",
  "Who is your the name of your first pet?",
  "Who do you call?",
  ];
  
  const [question, setquestion] = useState <null|string[]>(questionTypeDropdown);
  const questionFilterChange = (event:{filter:{field:string,operator:string,value:string}}) => {
          const filter=event.filter;
          const currentArray=question;
          const totalArray=questionTypeDropdown;
          const setFilterReturn = SetFilter({filter,currentArray,totalArray});
          setquestion(setFilterReturn.filteredArray);
  };
  
  const [questionValue, setquestionValue] = useState <null|string>(null);
  const questionChange = (e:{value:null|string}) => {
          setquestionValue(e.value);
  };

const [current, setCurrent] = useState<{
    currentPassword:string,
    newPassword:string,
    confirmNewPassword:string,
    resetAnswer:string,
    question:null|string,
}>({
  currentPassword:"",
  newPassword:"",
  confirmNewPassword:"",
  resetAnswer:"",
  question:questionValue,       
});

const passwordVisibility = (e:any) => {
  const buttonId = e.target.id;
  const inputId = buttonId+"-input";
  const inputElement = document.getElementById(inputId) as HTMLInputElement;
  if(inputElement){
    if(inputElement.type=="text"){
      inputElement.type="password";
      e.target.classList.add("strike");
    }
    else if(inputElement.type=="password"){
      inputElement.type="text";
      e.target.classList.remove("strike");
    }
  }
  seterrorPopup(false)
};

const [passwordPopup,setpasswordPopup] = useState<boolean>(false);
const [errorPopup,seterrorPopup] = useState<boolean>(false);

const togglePasswordPopup = () => {
  console.log("password is active")
  setpasswordPopup(true)
  seterrorPopup(false)
  const passwordElement = document.getElementById("popup-password-newPassword-input") as HTMLInputElement;
  const lengthElement = document.getElementById("userInputPasswordTellerLength") as HTMLDivElement;
  const lengthShapeElement = document.getElementById("userInputPasswordTellerLengthShape") as HTMLSpanElement;
  const numericElement = document.getElementById("userInputPasswordTellerNumeric") as HTMLDivElement;
  const numericShapeElement = document.getElementById("userInputPasswordTellerNumericShape") as HTMLSpanElement;
  const lowerElement = document.getElementById("userInputPasswordTellerLower") as HTMLDivElement;
  const lowerShapeElement = document.getElementById("userInputPasswordTellerLowerShape") as HTMLSpanElement;
  const upperElement = document.getElementById("userInputPasswordTellerUpper") as HTMLDivElement;
  const upperShapeElement = document.getElementById("userInputPasswordTellerUpperShape") as HTMLSpanElement;
  const specialElement = document.getElementById("userInputPasswordTellerSpecial") as HTMLDivElement;
  const specialShapeElement = document.getElementById("userInputPasswordTellerSpecialShape") as HTMLSpanElement;
  const firstElement = document.getElementById("userInputPasswordTellerFirst") as HTMLDivElement;
  const firstShapeElement = document.getElementById("userInputPasswordTellerFirstShape") as HTMLSpanElement;
  if(passwordElement){
    const passwordValue = passwordElement.value;
    CheckingPasswords.checkValidPasswordShower(
      passwordValue,
      lengthElement,
      lengthShapeElement,
      numericElement,
      numericShapeElement,
      lowerElement,
      lowerShapeElement,
      upperElement,
      upperShapeElement,
      specialElement,
      specialShapeElement,
      firstElement,
      firstShapeElement
      );
  }
}

const checkValidPassword = (e:any) => {
  const passwordElement = document.getElementById("popup-password-newPassword-input") as HTMLInputElement;
  if(passwordElement){
    const passwordValue = passwordElement.value
    const valid = CheckingPasswords.checkValidPassword(passwordValue);
    if(!valid){
      passwordElement.value=""
      console.log("invalid")
    }
    else{
      console.log("valid")
    }
  }
  setpasswordPopup(false)
  seterrorPopup(false)
}

  const pairs=[
    {name:"currentPassword",title:"* Current Password",style:"password","values":{onChange:passwordVisibility}},
    {name:"newPassword",title:"* New Password",style:"password","values":{passwordPopup:passwordPopup,onChange:passwordVisibility,onBlur:checkValidPassword,popupHelper:togglePasswordPopup}},
    {name:"confirmNewPassword",title:"* Confirm New Password",style:"password","values":{onChange:passwordVisibility}},
    {name:"resetAnswer",title:"* Password Reset Answer",style:"password","values":{onChange:passwordVisibility}},
    {name:"question",title:"* Password Reset Question",style:"single-select","values":{data:question,placeholder:"ANY",startValue:questionValue,onChange:questionChange,onFilterChange:questionFilterChange}},
    {name:"errorCode",title:"",style:"popupMessage","values":{errorPopup:errorPopup}},
  ];

  const setCurrentPassword = setCurrent;
  const pairsPassword = pairs;
  return {     
    questionValue,
    setCurrentPassword,
    pairsPassword,
    seterrorPopup
  };
};

export default PasswordUseStates;